import { render, staticRenderFns } from "./Attempt1.vue?vue&type=template&id=45ddadac&scoped=true&"
import script from "./Attempt1.vue?vue&type=script&lang=js&"
export * from "./Attempt1.vue?vue&type=script&lang=js&"
import style0 from "./Attempt1.vue?vue&type=style&index=0&id=45ddadac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ddadac",
  null
  
)

component.options.__file = "Attempt1.vue"
export default component.exports